module.exports = __webpack_public_path__ + "img/nuvola_0.4c75d053.png";